import { AppSection } from "components/AppSection";
import { AppSectionSubTitle } from "components/AppSectionSubTitle";
import { AppSectionTitle } from "components/AppSectionTitle";
import { useOrganismosList } from "./OrganismosListCtx";
import { AppSectionHeaderBox } from "components/AppSectionHeaderBox";
import { OrganismosListPageFilters } from "./OrganismosListPageFilters";
import { OrganismosListPageButtons } from "./OrganismosListPageButtons";
import { CenteredSpinner } from "components/CenteredSpinner";
import { Pagination } from "components/Pagination/Pagination";
import { OrganismosTable } from "./OrganismosTable";

export function OrganismosListPageSection()
{
  const {
    isLoading,
    page,
    setPage,
    limit,
    setLimit,
    cantidad,
    elementos,
  } = useOrganismosList();

  return (
  <AppSection>

    <AppSectionTitle title="Organismos"/>

    <AppSectionSubTitle subtitle="Desde acá podrás gestionar los organismos."/>

    <AppSectionHeaderBox>
        <OrganismosListPageFilters/>
        <OrganismosListPageButtons/>
    </AppSectionHeaderBox>

    <CenteredSpinner isLoading={isLoading}/>

    {!isLoading && elementos && (
      <>
        <OrganismosTable elementos={elementos}/>
        <Pagination
          totalItems={cantidad}
          currentPage={page}
          currentLimit={limit}
          onChangePage={(params) =>
          {
            setPage(+params.page);
            setLimit(+params.limit);
          }}
          showPaginationOnlyOnMoreThanPages={1}
        />
      </>
    )}

  </AppSection>
  )
}